import { Component, input } from '@angular/core';
import { AlertToast } from '../alert-toast/alert-toast';

/** One summary-banner item with a bold field label and trailing detail text. */
export interface FormErrorSummaryItem {
  emphasis: string;
  detail: string;
}

/**
 * Accessible validation summary banner for form sections.
 * Callers pass pre-translated title and message items.
 */
@Component({
  selector: 'app-form-error-summary',
  imports: [AlertToast],
  templateUrl: './form-error-summary.html',
  styleUrl: './form-error-summary.scss',
  host: { '[style.display]': "messages().length ? null : 'none'" },
})
export class FormErrorSummary {
  readonly title = input.required<string>();
  readonly messages = input<FormErrorSummaryItem[]>([]);
}
